
const AWS = require('aws-sdk');
const { SuccessResponse, ErrorResponse, ERROR } = require("./response");
const { Region } = require("./env");

const create_client = (creds) => {

  if (creds) {
    return new AWS.SSM(creds.to_service());
  }

  return new AWS.SSM({
    region: Region.region,
  });
}

const GetParameter = async (param_name, with_decryption= false) => {
  return await GetParameterC(null, param_name, with_decryption);
}

const GetParameterC = async (creds, param_name, with_decryption = false) => {
  const ssm = create_client(creds);
  const params = {
    Name: param_name,
    WithDecryption: with_decryption,
  }

  try {
    return SuccessResponse(await ssm.getParameter(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

const GetParameters = async (param_names) => {
  return await GetParametersC(null, param_names);
}

const GetParametersC = async (creds, param_names) => {
  const ssm = create_client(creds);
  const params = {
    Names: param_names,
  }

  try {
    const result = await ssm.getParameters(params).promise();
    const lut = {};
    result.Parameters.forEach(param => {
      lut[param.Name] = param.Value;
    });
    return SuccessResponse(lut);
  } catch (err) {
    return ErrorResponse(err);
  }
}


const GetParametersByPath = async (path, token) => {
  return await GetParametersByPathC(null, path, token);
}

const GetParametersByPathC = async (creds, path, token) => {
  const ssm = create_client(creds);
  const params = {
    NextToken: token,
    Path: path,
    Recursive: true,
  }

  try {
    return SuccessResponse(await ssm.getParametersByPath(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

const PutStringParameter =
  async (param_name, param_value, description, overwrite=true) => {
  return await PutStringParameterC(
    null, param_name, param_value, description, overwrite);
}

const PutStringParameterC =
  async (creds, param_name, param_value, description, overwrite=true) => {

    const ssm = create_client(creds);
    const params = {
      Name: param_name,
      Value: param_value,
      Type: "String",
      Description: description,
      Overwrite: overwrite,
    }

    try {
      return SuccessResponse(await ssm.putParameter(params).promise());
    } catch (err) {
      return ErrorResponse(err);
    }
}

const PutStringListParameter =
  async (param_name, param_values, description, overwrite=true) => {
  return await PutStringListParameterC(
    null, param_name, param_values, description, overwrite);
}

const PutStringListParameterC =
  async (creds, param_name, param_values, description, overwrite=true) => {

    const ssm = create_client(creds);
    const params = {
      Name: param_name,
      Value: param_values.join(","),
      Type: "StringList",
      Description: description,
      Overwrite: overwrite,
    }

    try {
      return SuccessResponse(await ssm.putParameter(params).promise());
    } catch (err) {
      return ErrorResponse(err);
    }

}

module.exports = {
  GetParameter, GetParameterC,
  PutStringParameter, PutStringParameterC,
  GetParameters, GetParametersC,
  PutStringListParameter, PutStringListParameterC,
  GetParametersByPath, GetParametersByPathC,
}